import { Group } from 'app/page/orders/model/charge-group';

export class TvStaticData {
    public static readonly TV_OFFER_NAME: string = 'RBO_IPTV_PRC';
    public static readonly TV_PRODUCT_NAME: string = 'RO_IPTV_PRC';
    public static readonly TV_PACKAGE_NAME: string = 'SRV_IPTV:PACKAGE';
    public static readonly RECORDING_MODE_NAME: string = 'SRV_IPTV:NPVR';
    public static readonly EXTRA_STB_NAME: string = 'SRV_IPTV:NR_OF_HUAWEI_STBS';
    public static readonly TV_CHANNEL_PACKAGE_OPTION_PREFIX: string = 'SRV_IPTV_CHANNEL_PKGS';
    public static readonly STREAMING_OPTION_PREFIX: string = 'SRV_EXT_STREAMING';
    public static readonly TV_PACKAGE_CATEGORY: string = 'TV_PKG';
    public static readonly TV_STREAMING_CHANNEL_CATEGORY: string = 'STREAMING';

    public static readonly TV_STREAMING_CHANNEL_HBO_NORDIC_CODE: string = 'SRV_IPTV_CHANNEL_PKGS_DK:CPKG_SVOD_HBO';
    public static readonly TV_STREAMING_CHANNEL_VIAPLAY_CODE: string = 'SRV_EXT_STREAMING:EXT_SVOD_VIAPLAY';
    public static readonly HBO_DISCOUNT_CHARGE_NAME: string = 'IPTV_HBO_1M_FREE';
    public static readonly VIAPLAY_DISCOUNT_CHARGE_NAME: string = 'EXT_SVOD_VIAPLAY_DISC';

    public static readonly TV_STREAMING_DISCOUNTS: Record<string, Group> = {
        [TvStaticData.TV_STREAMING_CHANNEL_HBO_NORDIC_CODE]: {
            chargeName: TvStaticData.HBO_DISCOUNT_CHARGE_NAME,
        },
        [TvStaticData.TV_STREAMING_CHANNEL_VIAPLAY_CODE]: {
            chargeName: TvStaticData.VIAPLAY_DISCOUNT_CHARGE_NAME,
        },
    };
}
